export const surveyInvite = `
🌟 Hi there!

We’d love to hear your thoughts. Please take a moment to complete our survey 📝

Thank you so much! 💛
`.trim()

export const surveyReminder = `
👋 Hi there!

Just a friendly reminder that you can still take our survey. Your feedback will help us improve 💛

Thank you for finding a moment for us 🙏
`.trim()
